(function () {
  if (window.__pdpLiveVariants) return;
  window.__pdpLiveVariants = true;
  var offerSelector = '[aria-label="Purchase options"]';
  var loadingStyle = document.createElement('style');
  loadingStyle.textContent = '.npv2 .pdp-choice-loading{position:relative;cursor:progress}' +
    '.npv2 .pdp-choice-loader{position:absolute;inset:0;z-index:3;display:grid;place-items:center;border-radius:inherit;background:rgba(255,255,255,.78);pointer-events:none}' +
    '.npv2 .pdp-choice-loader::after{content:"";width:22px;height:22px;box-sizing:border-box;border:2px solid #d6dac9;border-top-color:#496c23;border-radius:50%;animation:pdp-choice-spin .65s linear infinite}' +
    '.npv2 .npv2-offer__pill.pdp-choice-loading>.pdp-choice-loader{display:grid;padding:0;border:0;border-radius:999px;background:#2a2611;color:#fff}' +
    '.npv2 .npv2-offer__pill.pdp-choice-loading>.pdp-choice-loader::after{border-color:rgba(255,255,255,.35);border-top-color:#fff}' +
    '@keyframes pdp-choice-spin{to{transform:rotate(360deg)}}' +
    '@media(prefers-reduced-motion:reduce){.npv2 .pdp-choice-loader::after{animation:none}}';
  document.head.appendChild(loadingStyle);

  function paintOffer(root, active) {
    if (!active) return;
    root.querySelectorAll('[data-npv2-card]').forEach(function (card) {
      var on = card === active;
      if (on) card.setAttribute('data-selected', 'true');
      else card.removeAttribute('data-selected');
      var label = card.querySelector('[data-npv2-label]');
      if (label) { if (on) label.setAttribute('data-selected', 'true'); else label.removeAttribute('data-selected'); }
      var box = card.querySelector('[data-npv2-box]');
      if (box) box.className = root.getAttribute(on ? 'data-npv2-sel' : 'data-npv2-unsel');
      var radio = card.querySelector('[data-npv2-radio]');
      if (radio) radio.checked = on;
      var disclosure = card.querySelector('.react-aria-Disclosure');
      if (disclosure) { if (on) disclosure.setAttribute('data-expanded', 'true'); else disclosure.removeAttribute('data-expanded'); }
      var panel = card.querySelector('[data-npv2-panel]');
      if (panel) {
        panel.hidden = !on;
        panel.setAttribute('aria-hidden', String(!on));
        panel.style.setProperty('--disclosure-panel-height', on ? 'auto' : '0px');
      }
    });
    var plan = document.querySelector('[data-npv2-plan-input]');
    if (plan) {
      plan.value = active.getAttribute('data-npv2-plan-id') || '';
      plan.disabled = !plan.value;
    }
    var title = active.querySelector('.npv2-offer__title');
    var price = active.querySelector('[data-npv2-price]');
    var compare = active.querySelector('.npv2-offer__was');
    document.querySelectorAll('[data-npv2-sticky-title]').forEach(function (el) { el.textContent = title ? title.textContent : ''; });
    document.querySelectorAll('[data-npv2-sticky-price]').forEach(function (el) { el.textContent = price ? price.textContent : ''; });
    document.querySelectorAll('[data-npv2-sticky-compare]').forEach(function (el) { el.textContent = compare ? compare.textContent : ''; el.hidden = !compare; });
    var other = Array.from(root.querySelectorAll('[data-npv2-card]')).find(function (card) { return card !== active; });
    var alt = document.querySelector('[data-npv2-alt]');
    if (alt) {
      alt.hidden = !other;
      if (other) {
        alt.setAttribute('data-npv2-target', other.getAttribute('data-npv2-card'));
        var text = alt.querySelector('span');
        var otherTitle = other.querySelector('.npv2-offer__title'), otherPrice = other.querySelector('[data-npv2-price]');
        if (text) text.textContent = (otherTitle ? otherTitle.textContent : '') + ' — ' + (otherPrice ? otherPrice.textContent : '');
      }
    }
  }

  async function update(root, url, focus, control) {
    if (root.dataset.variantPending) return;
    var form = document.getElementById('npv2-product-form');
    if (!form || form.hasAttribute('data-npv2-discount-pending') || root.querySelector('[data-pdp-gift-picker][data-pending]')) return;
    root.dataset.variantPending = 'true';
    root.setAttribute('aria-busy', 'true');
    var loadingControl = control && (control.closest('.npv2-offer__pill') || control);
    var loader;
    if (loadingControl) {
      loadingControl.classList.add('pdp-choice-loading');
      loadingControl.setAttribute('aria-busy', 'true');
      loader = document.createElement('span');
      loader.className = 'pdp-choice-loader';
      loader.setAttribute('aria-hidden', 'true');
      loadingControl.appendChild(loader);
    }
    var buttons = Array.from(document.querySelectorAll('[data-npv2-atc], [data-npv2-submit]'));
    var disabledBefore = buttons.map(function (button) { return button.disabled; });
    buttons.forEach(function (button) { button.disabled = true; });
    var notice = root.querySelector('[data-pdp-variant-status]');
    if (!notice) {
      notice = document.createElement('p');
      notice.setAttribute('data-pdp-variant-status', '');
      notice.setAttribute('role', 'status');
      root.querySelector(offerSelector).insertAdjacentElement('afterend', notice);
    }
    notice.hidden = true;
    notice.textContent = '';
    var successful = false;
    try {
      // Reuse Shopify's rendered prices, allocations and option targets without navigating.
      var requestUrl = new URL(url);
      requestUrl.searchParams.set('section_id', root.dataset.pdpLiveVariants);
      var response = await fetch(requestUrl.toString(), {headers: {Accept: 'text/html'}, cache: 'no-store'});
      if (!response.ok) throw new Error('Variant update failed');
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var fresh = doc.querySelector('[data-pdp-live-variants], [data-npv2-root]');
      var freshInput = fresh && doc.querySelector('#npv2-product-form input[name="id"]');
      if (!freshInput || freshInput.value !== url.searchParams.get('variant') || !fresh.querySelector(offerSelector)) throw new Error('Incomplete variant response');
      var quantity = form.querySelector('[name="quantity"]');
      var savedQuantity = quantity && quantity.value;
      form.querySelector('input[name="id"]').value = freshInput.value;
      var oldOptions = root.querySelector('[data-npv2-flavor]');
      var newOptions = fresh.querySelector('[data-npv2-flavor]');
      if (oldOptions && newOptions) oldOptions.replaceWith(newOptions);
      root.querySelector(offerSelector).replaceWith(fresh.querySelector(offerSelector));
      root.dataset.liveOffers = 'true';
      if (quantity) quantity.value = savedQuantity;
      ['.npv2-hero__price'].forEach(function (selector) {
        var old = root.querySelector(selector), next = fresh.querySelector(selector);
        if (old && next) old.replaceWith(next);
      });
      paintOffer(root, root.querySelector('[data-npv2-card][data-selected="true"]') || root.querySelector('[data-npv2-card="once"]'));
      var freshAtc = fresh.querySelector('[data-npv2-atc]');
      buttons.forEach(function (button) {
        button.disabled = freshAtc ? freshAtc.disabled : false;
        button.setAttribute('aria-disabled', String(button.disabled));
      });
      var image = fresh.querySelector('[data-npv2-track="gallery"] img');
      if (image) {
        var path = new URL(image.src, location.href).pathname;
        var thumb = Array.from(root.querySelectorAll('[data-npv2-thumbs] [data-npv2-thumb]')).find(function (button) {
          var img = button.querySelector('img');
          return img && new URL(img.src, location.href).pathname === path;
        });
        if (thumb) thumb.click();
      }
      history.replaceState(history.state, '', url.toString());
      document.dispatchEvent(new CustomEvent('pdp:variant-updated', {detail: {variantId: freshInput.value}}));
      if (focus) {
        var target = root.querySelector(focus);
        if (target) target.focus({preventScroll: true});
      }
      notice.textContent = '';
      successful = true;
    } catch (error) {
      notice.hidden = false;
      notice.textContent = 'Unable to update your selection. Please try again.';
      var currentPlan = document.querySelector('[data-npv2-plan-input]');
      root.querySelectorAll('[data-npv2-freq]').forEach(function (input) {
        input.checked = !!currentPlan && input.value === currentPlan.value;
        var pill = input.closest('.npv2-offer__pill');
        if (pill) pill.classList.toggle('is-on', input.checked);
      });
    } finally {
      if (loader) loader.remove();
      if (loadingControl) {
        loadingControl.classList.remove('pdp-choice-loading');
        loadingControl.removeAttribute('aria-busy');
      }
      delete root.dataset.variantPending;
      root.removeAttribute('aria-busy');
      if (!successful) buttons.forEach(function (button, index) { button.disabled = disabledBefore[index]; });
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-npv2-variant], [data-gift-variant], [data-npv2-alt]');
    var root = event.target.closest('[data-pdp-live-variants]');
    if (!root && button && button.matches('[data-npv2-alt]')) root = document.querySelector('[data-pdp-live-variants]');
    if (!root) return;
    if (root.dataset.variantPending && event.target.closest('[data-npv2-card], [data-npv2-variant]')) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    if (button && button.matches('[data-npv2-alt]') && root.dataset.liveOffers) {
      event.preventDefault(); event.stopImmediatePropagation();
      paintOffer(root, root.querySelector('[data-npv2-card="' + button.dataset.npv2Target + '"]'));
      return;
    }
    var picker = button && button.closest('[data-pdp-gift-picker]');
    var legacyGift = picker && picker.dataset.legacyGifts === 'true';
    if (button && !button.disabled && (button.hasAttribute('data-npv2-variant') || legacyGift)) {
      event.preventDefault(); event.stopImmediatePropagation();
      var url = new URL(location.href);
      var id = legacyGift ? button.dataset.targetVariant : button.dataset.npv2Variant;
      if (!id) return;
      url.searchParams.set('variant', id);
      var plan = document.querySelector('[data-npv2-plan-input]');
      var allowed = (button.dataset.npv2VariantPlans || '').split(',');
      if (!legacyGift && plan && !plan.disabled && allowed.indexOf(plan.value) !== -1) url.searchParams.set('selling_plan', plan.value);
      else url.searchParams.delete('selling_plan');
      if (legacyGift) {
        try { sessionStorage.setItem('pdp-gift-' + picker.dataset.productId, button.dataset.giftVariant); } catch (_) {}
      }
      var focus = legacyGift ? '[data-gift-variant="' + button.dataset.giftVariant + '"]' : '[data-npv2-variant="' + id + '"]';
      update(root, url, focus, button);
      return;
    }
    // Fresh cards use delegated behavior; gallery and cart controls retain their original listeners.
    var card = event.target.closest('[data-npv2-card]');
    if (card && root.dataset.liveOffers) {
      paintOffer(root, card);
      if (event.target.closest('[data-npv2-label]')) event.preventDefault();
    }
  }, true);

  document.addEventListener('change', function (event) {
    var choice = event.target.closest('[data-npv2-freq]');
    var root = choice && choice.closest('[data-pdp-live-variants]');
    if (!root) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var url = new URL(location.href);
    url.searchParams.set('variant', document.querySelector('#npv2-product-form input[name="id"]').value);
    url.searchParams.set('selling_plan', choice.value);
    update(root, url, '[data-npv2-freq][value="' + choice.value + '"]', choice);
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.getAttribute('id') === 'npv2-product-form' && document.querySelector('[data-pdp-live-variants][data-variant-pending]')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
})();
